import React from "react";
import { ITheme, Theme } from "./theme";

/**
 * Probably an overkill, but we may want to set a MUI theme or some kind of
 * global theme in the future.
 */
export const ThemeContext = React.createContext<ITheme | null>(null);

export const ThemeProvider = ({
  children,
}: React.PropsWithChildren): React.ReactElement => {
  const [theme] = React.useState(Theme);

  return (
    <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
  );
};
